import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { VolunteerSignupSpecialist } from '@interfaces';
import { AppService } from '../../../../../../services';
import { VolunteeringAreaService } from '../../../../volunteering-area.service';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(service: VolunteeringAreaService, util: UtilityService, dialogService: DialogService, app: AppService): GridSetup<VolunteerSignupSpecialist> {

	return {
		rowName: { singular: 'Sign Ups Specialist', plural: 'Sign Ups Specialists' },
		getRowKey: row => '' + row.volunteerSignupSpecialistTopicId,
		stateKey: 'specialist-sign-up-grid',
		actions: getActions(service, dialogService),
		buttons: [],
		columns: getColumns(util, app),
	}
}
